<app-card-table
    #suklCertificatesTable
    [tableTitle]="title()"
    [gridData]="store.data.getServiceCertificates()"
    [refreshCallback]="store.api.getServiceCertificates"
    [columns]="columns"
    [additionalFilter]="additionalFilters()"
    [translatePrefix]="'common.'"
    [hideCheckboxes]="true"
    (deleteCallbackWithEvent)="deleteCertificate($event)"
    (createCallback)="addCertificate()"
>
</app-card-table>
